import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mb-8 md:mb-12',
    top: 'relative mx-auto mt-10 flex max-w-360 flex-col-reverse justify-between gap-6 px-3 lg:flex-row lg:items-center lg:px-10',
    city: '',
    tabs: 'bg-blue-light flex w-fit gap-1 rounded-[100px] p-1',
    tab: 'flex-center flex h-10 w-42.5 cursor-pointer rounded-[100px] lg:w-53.5',
    filters:
      'mx-auto mt-6 flex max-w-360 flex-col justify-between gap-5 px-3 lg:mt-10 lg:flex-row lg:px-10',
    search: 'w-full',
    filter: 'w-full lg:max-w-[33.3%]',
    content: 'mt-10',
    searchInput: 'heading-m'
  },
  variants: {
    active: {
      true: {
        tab: 'bg-blue-dark text-white'
      }
    }
  }
});
